import * as React from "react";
const SvgMail = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, fill: "none", viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#4A5568", d: "M33.333 14.667H14.667A2.33 2.33 0 0 0 12.345 17l-.012 14a2.34 2.34 0 0 0 2.334 2.333h18.666A2.34 2.34 0 0 0 35.667 31V17a2.34 2.34 0 0 0-2.334-2.334m0 4.666L24 25.167l-9.333-5.834V17L24 22.833 33.333 17z" }));
export default SvgMail;
